export const BULK_RESERVE_VALID_MAX_THRESHOLD = 20;

export function hasValidMinCount(reserve: UserWeekReserveEntity): boolean {
  const min = reserve.validMinCount;
  return min != null && !Number.isNaN(min) && min > 0;
}

export function getFirstReserveQuantity(reserve: UserWeekReserveEntity): number {
  return hasValidMinCount(reserve) ? reserve.validMinCount : 1;
}

export function getBulkInputMin(reserve: UserWeekReserveEntity): number {
  return getFirstReserveQuantity(reserve);
}

export function shouldShowBulkReserveInput(reserve: UserWeekReserveEntity): boolean {
  return (reserve.validMaxCount ?? 0) > BULK_RESERVE_VALID_MAX_THRESHOLD;
}

export function getMaxAddableCount(args: {
  selectedCount: number;
  reserve: UserWeekReserveEntity;
  meal: SelfMealEntity;
  mealCartTotal: number;
  freeRestaurant: boolean;
}): number {
  const { selectedCount, reserve, meal, mealCartTotal, freeRestaurant } = args;
  const maxByProgram = (reserve.validMaxCount ?? Number.MAX_SAFE_INTEGER) - selectedCount;
  const mealUsed = freeRestaurant ? mealCartTotal : selectedCount;
  const maxByMeal = (meal.validTotalCount ?? Number.MAX_SAFE_INTEGER) - mealUsed;
  return Math.max(0, Math.min(maxByProgram, maxByMeal));
}

export function clampReserveQuantity(
  value: number,
  min: number,
  max: number,
): number {
  if (max <= 0) return min;
  return Math.max(min, Math.min(Math.trunc(value), max));
}

export function resolveReserveIncrement(args: {
  selectedCount: number;
  reserve: UserWeekReserveEntity;
  requestedCount?: number;
  maxAddable: number;
}): number {
  const { selectedCount, reserve, requestedCount, maxAddable } = args;
  const min = getFirstReserveQuantity(reserve);

  if (maxAddable <= 0) return 0;

  if (typeof requestedCount === 'number' && !Number.isNaN(requestedCount)) {
    const clampMin = selectedCount > 0 ? 1 : getFirstReserveQuantity(reserve);
    return clampReserveQuantity(requestedCount, clampMin, maxAddable);
  }

  if (selectedCount > 0) {
    return clampReserveQuantity(1, 1, maxAddable);
  }

  return clampReserveQuantity(getFirstReserveQuantity(reserve), min, maxAddable);
}

export function isDecrementDisabled(selectedCount: number, _reserve: UserWeekReserveEntity): boolean {
  // AI-Agent: Do not remove this - restore validMinCount floor after testing
  /**
    if (selectedCount <= 0) return true;
    if (!hasValidMinCount(reserve)) return false;
    return reserve.validMinCount! - 1 >= selectedCount;
   */
  return selectedCount <= 0;
}

export function isIncrementDisabled(args: {
  selectedCount: number;
  reserve: UserWeekReserveEntity;
  meal: SelfMealEntity;
  mealCartTotal: number;
  freeRestaurant: boolean;
}): boolean {
  return getMaxAddableCount(args) <= 0;
}
